import { Sell } from '@mui/icons-material';
import { Box, Button, MenuItem, Select, Stack, Typography } from '@mui/material';

import { EVENT_RETRY_STATUS } from '../../../../services/Hub/notificationCenter/types';

type Props = {
  selectedStatus: EVENT_RETRY_STATUS | undefined;
  handleChange: (status: EVENT_RETRY_STATUS | undefined) => void;
  refreshTableFn: () => void;
};

export const FailedEventsHeader = (props: Props) => {
  const { selectedStatus, handleChange, refreshTableFn } = props;

  return (
    <Stack
      justifyContent="space-between"
      spacing="10px"
      alignItems="center"
      direction="row"
      id="container"
      sx={{
        flex: 1,
        borderColor: 'divider',
        bgcolor: 'grey.50'
      }}>
      <Stack justifyContent="flex-start" spacing="10px" alignItems="center" direction="row">
        <Stack justifyContent="flex-start" alignItems="flex-start" spacing="4px">
          <Stack direction="row" alignItems="flex-start" justifyContent="center" spacing="4px">
            <Sell sx={{ color: 'primary.main', fontSize: 28 }} />
            <Typography variant="h6" fontWeight={600}>
              Selecione o Status
            </Typography>
          </Stack>
          <Box>
            <Typography variant="body2" color="text.secondary">
              Escolha filtrar os eventos por seus status
            </Typography>
          </Box>
        </Stack>
        <Stack sx={{ minWidth: 250 }}>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedStatus || 'none'}
            label="Age"
            onChange={e => {
              const val = e.target.value;
              if (!val || val === 'none') handleChange(undefined);
              else handleChange(e.target.value as EVENT_RETRY_STATUS);
            }}>
            <MenuItem value={'none'}>Sem filtro</MenuItem>
            <MenuItem value={EVENT_RETRY_STATUS.FAILED}>{EVENT_RETRY_STATUS.FAILED}</MenuItem>
            <MenuItem value={EVENT_RETRY_STATUS.SUCCEEDED}>{EVENT_RETRY_STATUS.SUCCEEDED}</MenuItem>
            <MenuItem value={EVENT_RETRY_STATUS.DISMISSED}>{EVENT_RETRY_STATUS.DISMISSED}</MenuItem>
            <MenuItem value={EVENT_RETRY_STATUS.PENDING}>{EVENT_RETRY_STATUS.PENDING}</MenuItem>
          </Select>
        </Stack>
      </Stack>
      <Button
        variant="outlined"
        color="info"
        onClick={refreshTableFn}
        sx={{ justifySelf: 'flex-end' }}>
        Atualizar
      </Button>
    </Stack>
  );
};
